export const fontWeightAndStyleKeys = {
  Bold: 'Bold',
  BoldItalic: 'BoldItalic',
  Normal: 'Normal',
  Italic: 'Italic',
}

export const fontWeightAndStyleValues = {
  [fontWeightAndStyleKeys.Bold]: 'Bold',
  [fontWeightAndStyleKeys.BoldItalic]: 'BoldItalic',
  [fontWeightAndStyleKeys.Normal]: 'Normal',
  [fontWeightAndStyleKeys.Italic]: 'Italic',
}

export const fontWeightAndStyleLabels = {
  [fontWeightAndStyleKeys.Bold]: 'Bold',
  [fontWeightAndStyleKeys.BoldItalic]: 'Bold-Italic',
  [fontWeightAndStyleKeys.Normal]: 'Normal',
  [fontWeightAndStyleKeys.Italic]: 'Italic',
}

export function findFontWeightAndStyleKeyByValue(value: string) {
  return Object.keys(fontWeightAndStyleValues).find(key => fontWeightAndStyleValues[key] === value)
}
